import React from 'react';
import { ROUTES } from './constants';
import { Route } from 'circe/routing/provider';
import { AUTHORITIES } from 'domain/fuse/auth/constants';

import RequireAuth from 'circe/authorization/components/AuthorizationRoute';
import { loadComponent } from 'domain/layout/utils';

/* istanbul ignore next */
const container = loadComponent(() => import('./components/Create'));

const zoneContainer = RequireAuth(container, [AUTHORITIES.ACCOUNT_ADMIN], '/');

const queryContainer = loadComponent(() => import('./components/Query'));
const zoneQueryContainer = RequireAuth(queryContainer, [AUTHORITIES.ACCOUNT_ADMIN], '/');

const UpdateContainer = loadComponent(() => import('./components/Update'));
const zoneUpdateContainer = RequireAuth(UpdateContainer, [AUTHORITIES.ACCOUNT_ADMIN], '/');

const Routes = () => {
  return [
    <Route path={`${ROUTES.ROOT}`} key={ROUTES.ROOT} exact component={zoneQueryContainer} />,
    <Route
      path={`${ROUTES.ROOT}/create`}
      exact
      key={`${ROUTES.ROOT}/CREATE`}
      component={zoneContainer}
    />,
    <Route
      path={`${ROUTES.ROOT}/update/:id`}
      exact
      key={`${ROUTES.ROOT}/UPDATE`}
      component={zoneUpdateContainer}
    />,
  ];
};

export default Routes;
